import { defineStore } from 'pinia'
import axios from 'axios'

export const useAuthStore = defineStore('auth', {
  state: () => ({
    token: localStorage.getItem('token'),
    returnUrl: 'profile' as string,
    profile: JSON.parse(localStorage.getItem('profile') || '{}'),
    monitoring: JSON.parse(localStorage.getItem('monitoring') || '{}'),
    active_monid: localStorage.getItem('active_monid') || '2',
    prgBakalavr: localStorage.getItem('prgBakalavr'),
    prgSPO: localStorage.getItem('prgSPO'),
    prgVK: localStorage.getItem('prgVK'),
    prgSpec: localStorage.getItem('prgSpec'),
    prgMagistr: localStorage.getItem('prgMagistr'),
    base_url: import.meta.env.VITE_BASE_URL,
  }),
  actions: {
    async register(
      username: string,
      password: string,
      FIO: string,
      headOffice: number,
      job: string,
      region: number,
      structOffice: number,
      telmobile: string,
      telwork: string,
      role: number,
    ) {
      await axios
        .post(this.base_url + '/auth/register', {
          email: username,
          password: password,
          role: role,
          FIO: FIO,
          headOffice: headOffice,
          job: job,
          region: region,
          structOffice: structOffice,
          telmobile: telmobile,
          telwork: telwork,
        })
        .then(() => Promise.resolve('complete'))
        .catch((error) => {
          Promise.reject(error)
        })
    },
    async login(username: string, password: string) {
      try {
        let token = ''
        const logindata = new FormData()
        logindata.set('username', username)
        logindata.set('password', password)
        await axios
          .post(this.base_url + '/auth/jwt/login', logindata, { headers: { 'Content-Type': 'multipart/form-data' } })
          .then((response) => {
            token = response.data.access_token
            this.token = token
            localStorage.setItem('token', token)
          })
          .catch((error) => Promise.reject(error))
        await this.getuser()
          .then(() => Promise.resolve('complete'))
          .catch((error) => {
            Promise.reject(error)
          })
        await this.getactivemonid()
          .then(() => Promise.resolve('complete'))
          .catch((error) => {
            Promise.reject(error)
          })
        return await this.getmonitoring()
          .then(() => Promise.resolve('complete'))
          .catch((error) => {
            Promise.reject(error)
          })
      } catch (error) {
        console.log(error)
        return Promise.reject(error)
      }
    },
    async logout() {
      await axios
        .post(this.base_url + '/auth/jwt/logout', null, {
          headers: {
            Authorization: `Bearer ${this.token}`,
          },
        })
        .catch((error) => console.log(error))
      this.token = null
      localStorage.removeItem('token')
      localStorage.removeItem('profile')
    },
    async getuser() {
      let profile = ''
      return await axios
        .get(this.base_url + '/users/me', {
          headers: {
            Authorization: `Bearer ${this.token}`,
          },
        })
        .then((response) => {
          profile = response.data
          this.profile = profile
          localStorage.setItem('profile', JSON.stringify(profile))
          Promise.resolve('complete')
        })
        .catch((error) => Promise.reject(error))
    },
    async getmonitoring() {
      let monitoring = ''
      return await axios
        .get(this.base_url + '/lists/monitoring', {
          headers: {
            Authorization: `Bearer ${this.token}`,
          },
        })
        .then((response) => {
          monitoring = response.data
          this.monitoring = monitoring
          localStorage.setItem('monitoring', JSON.stringify(monitoring))
          Promise.resolve('complete')
        })
        .catch((error) => Promise.reject(error))
    },
    async getactivemonid() {
      let active_monid = ''
      return await axios
        .get(this.base_url + '/lists/activemonid', {
          headers: {
            Authorization: `Bearer ${this.token}`,
          },
        })
        .then((response) => {
          active_monid = response.data[0].active_monid
          this.active_monid = active_monid
          localStorage.setItem('active_monid', active_monid)
          Promise.resolve('complete')
        })
        .catch((error) => Promise.reject(error))
    },
  },
})
